import React from 'react'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_ESTIMACION_SEMANAL, TABLA_SIMULACION_POOL } from '../../../config/tables'

function EstimacionSemanalStock (props) {
  const { simulacion } = props
  return (
    <>
      { simulacion
        ? <MuiTable id={TABLA_SIMULACION_POOL} />
        : <MuiTable id={TABLA_ESTIMACION_SEMANAL} />
      }
    </>

  )
}

export default EstimacionSemanalStock
